import _t from 'i18n!nls/discussions';

export const isRoleVerified = (role: string = '') => {
  switch (role) {
    case 'INSTRUCTOR':
    case 'TEACHING_STAFF':
    case 'UNIVERSITY_ADMIN':
    case 'DATA_COORDINATOR':
      return true;
    default:
      return false;
  }
};

export const getMaybeVerifiedLabel = (isVerified: boolean, role: string = '') => {
  return isVerified ? _t('Verified #{role}', { role }) : `${role}`;
};

export const decorateRoleLabel = (role: string = '', label: string = '') => {
  const isVerified = isRoleVerified(role);
  return getMaybeVerifiedLabel(isVerified, label);
};
